import { FolderKanban } from 'lucide-react'

export function ProjectEmptyState() {
  return (
    <div data-testid="projects-empty-state" className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16">
      <FolderKanban className="h-12 w-12 text-muted-foreground" />
      <h3 className="mt-4 text-lg font-semibold">No projects available yet</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Projects you have access to will appear here.
      </p>
    </div>
  )
}
